
export default function Contact() {
  const navigationLinks = [
    {
      title: 'Company',
      links: ['About', 'Products', 'Features']
    },
    {
      title: 'Support',
      links: ['Help Center', 'Documentation', 'FAQ']
    },
    {
      title: 'Legal',
      links: ['Privacy Policy', 'Terms of Service', 'Compliance']
    },
    {
      title: 'Connect',
      links: ['LinkedIn', 'Twitter', 'GitHub']
    }
  ];

  const contactInfo = [
    { label: 'Address', value: 'Kralja Petra Svacica 14' },
    { label: 'City', value: 'Husain' },
    { label: 'Zip', value: '44320' },
    { label: 'Country', value: 'Croatia' },
    { label: 'Email', value: 'help@lemurdoo.com' },
    { label: 'Number', value: '+1 7744589760' }
  ];

  return (
    <section id="contact" className="bg-gray-900 pt-32 pb-20 px-20">
      <div className="max-w-[1440px] mx-auto">
        <div className="grid grid-cols-4 gap-12 mb-40 pb-12 border-b border-gray-800">
          {navigationLinks.map((section, index) => (
            <div key={index}>
              <h3 className="text-base font-medium text-white mb-4">{section.title}</h3>
              <div className="w-full h-px bg-gray-700 mb-6"></div>
              <div className="space-y-4">
                {section.links.map((link, linkIndex) => (
                  <div key={linkIndex}>
                    <span className="text-sm text-gray-400 hover:text-orange-500 transition-colors duration-300 cursor-pointer">
                      {link}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
        
        <div className="grid grid-cols-2 gap-20 items-start">
          <div>
            <div className="mb-6">
              <h2 className="text-7xl font-bold text-white inline-block" style={{ fontFamily: 'Playfair Display, serif' }}>
                LEMUR d.o.o.
              </h2>
            </div>
            <p className="text-5xl font-light text-gray-400 mb-8" style={{ fontFamily: 'Playfair Display, serif' }}>
              iOS Excellence
            </p>
            
            <div className="flex items-center gap-4 mb-6">
              <div className="w-20 h-0.5 bg-orange-500"></div>
              <span className="text-xs text-gray-500">© 2025 All rights reserved</span>
            </div>
            
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-block text-sm text-gray-500 hover:text-orange-500 transition-colors duration-300 cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
          
          <div className="grid grid-cols-2 gap-x-12 gap-y-6">
            {contactInfo.map((info, index) => (
              <div key={index}>
                <div className="text-xs uppercase tracking-wider text-gray-500 mb-2 flex items-center gap-2">
                  {info.label === 'Address' && <i className="ri-map-pin-line text-sm"></i>}
                  {info.label === 'City' && <i className="ri-building-line text-sm"></i>}
                  {info.label === 'Zip' && <i className="ri-mail-line text-sm"></i>}
                  {info.label === 'Country' && <i className="ri-global-line text-sm"></i>}
                  {info.label === 'Email' && <i className="ri-mail-send-line text-sm"></i>}
                  {info.label === 'Number' && <i className="ri-phone-line text-sm"></i>}
                  {info.label}
                </div>
                <div className="text-base text-white">
                  {info.value}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
